<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/casa-ferreirinha')">Casa Ferreirinha
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/howards-folly')">Howard’s Folly
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/prats-and-symington')">Prats and
                        Symington (Chryseia)
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-crasto')">Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vale-meao')">Quinta Do Vale
                        Meao
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vallado')">Quinta Do Vallado
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vesuvio')">Quinta Do Vesuvio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/roquette-cazes-quinta')">Roquette
                        &amp; Cazes — Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/symington')">Symington
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Roquette &amp; Cazes — Quinta do Crasto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Quando due titani della vinificazione si incontrano, le possibilità che producano qualcosa di diverso dai vini superbi sono alte
                        sottile. E la joint venture tra Jorge Roquette (Quinta do Castro) e Jean-Michel Cazes
                        (Château Lynch-Bages) lo dimostra. Realizzato con il know-how bordolese e le uve della valle del Douro
                        il risultato: Quinta do Crasto Roquette &amp; Cazes è l'ibrido perfetto tra storia, abilità
                        e amicizia. Nonostante entrambe le case abbiano radici molto profonde nella storia della vinificazione, Quinta do
                        Crasto risale al 1615 e Lynch Bages può rivendicare un'eredità del XVI secolo: la JV è un
                        idea relativamente recente, nata dalla visione condivisa di due uomini.
                    </div>

                    <div class="howto-title2">Due uomini: una visione</div>
                    <div class="howto-text">
                        Due uomini, due voci ovviamente significano due vini; Il 2002 ha visto la prima annata di Xisto e il 2006 ha visto il fratello minore Roquette &amp; Cazes rilasciato sul mercato. Xisto è stato un successo immediato e l'offerta del 2003 è stata votata come "Exhibition Discovery" al Vinexpo 2005. Il superlativo di Caze
                        l'esperienza enologica ha funzionato particolarmente bene con le varietà della valle del Douro e con quelle di Roquette
                        la frutta a sua volta ha risposto egregiamente ai protocolli di vinificazione in stile bordolese di Caze. Questi
                        prevedeva l'accelerazione dei rimontaggi per i primi tre giorni di fermentazione e la permanenza di un periodo più lungo
                        tempo di macerazione, conferendo a Xisto la sua eccezionale concentrazione, una rarità incredibile per un prodotto
                        dalla Valle del Douro.
                    </div>

                    <div class="howto-title2">Xisto contro Roquette &amp; Caze?</div>
                    <div class="howto-text">
                        Dal punto di vista degli investitori Xisto è doppiamente desiderabile in quanto la produzione è limitata a metà
                        3.000-4.000 bottiglie all'anno. 2011 Il prezzo medio è di circa € 100 a bottiglia (in Europa) con
                        i prezzi sono rimasti stabili negli ultimi 24 mesi (maggio-2019) e ha ricevuto 95 punti da Wine
                        Avvocato, suggerendo che Xisto è un'aggiunta eccellente al portafoglio di qualsiasi investitore di vino o
                        cantina. Per chi è più interessato a bere Roquette &amp; L'oro liquido di Caze, la Roquette
                        &amp; Le annate 2013 e 2014 di Cazes sono una scelta eccellente, ottenendo un punteggio elevato al Decanter World
                        Wine Awards e International Wine Challenge.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Roquette &amp; Cazes — Quinta do Crasto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn zwei Winzer-Titanen aufeinandertreffen, stehen die Chancen gut, dass sie etwas anderes als hervorragende Weine herstellen
                        schlank. Und das Joint Venture zwischen Jorge Roquette (Quinta do Castro) und Jean-Michel Cazes
                        (Château Lynch-Bages) beweist genau das. Hergestellt mit Bordelaise-Know-how und Douro-Tal-Trauben
                        das Ergebnis: Quinta do Crasto Roquette &amp; Cazes ist die perfekte Mischung aus Geschichte und Können
                        und Freundschaft. Obwohl beide Häuser sehr tief in der Geschichte der Weinherstellung verwurzelt sind – Quinta do
                        Crasto stammt aus dem Jahr 1615 und Lynch Bages kann auf ein Erbe aus dem 16. Jahrhundert zurückblicken – das JV ist ein
                        relativ junge Idee, die aus der gemeinsamen Vision zweier Männer hervorgegangen ist.
                    </div>

                    <div class="howto-title2">Zwei Männer: eine Vision</div>
                    <div class="howto-text">
                        Zwei Männer, zwei Stimmen bedeuten natürlich zwei Weine; Im Jahr 2002 erschien der erste Jahrgang von Xisto und im Jahr 2006 folgten die jüngeren Geschwister Roquette &amp; Cazes auf den Markt gebracht. Xisto war sofort ein Erfolg und das Angebot von 2003 wurde auf der Vinexpo 2005 zur „Exhibition Discovery“ gewählt. Cazes Superlativ
                        Die Weinbaukompetenz funktionierte besonders gut mit den Rebsorten des Douro-Tals und Roquette
                        Die Früchte reagierten wiederum bewundernswert auf Cazes Weinbereitungsprotokolle im Bordeaux-Stil. Diese
                        Dazu gehörte, das Pumpen in den ersten drei Tagen der Gärung zu beschleunigen und länger stehen zu lassen
                        Mazerationszeit, die Xisto seine außergewöhnliche Konzentration verleiht – eine unglaubliche Seltenheit für ein Produkt
                        aus dem Douro-Tal.
                    </div>

                    <div class="howto-title2">Xisto vs. Roquette &amp; Caze?</div>
                    <div class="howto-text">
                        Aus Sicht der Investoren ist Xisto doppelt begehrenswert, da die Produktion auf 1,5 % begrenzt ist
                        3.000-4.000 Flaschen pro Jahr. 2011 Der durchschnittliche Preis liegt bei etwa 100 € pro Flasche (in Europa).
                        Die Preise blieben in den letzten 24 Monaten (Mai 2019) stabil und wurden von Wine mit 95 Punkten ausgezeichnet
                        Advocate schlägt vor, dass Xisto eine hervorragende Ergänzung für das Portfolio eines jeden Weininvestors ist
                        Keller. Für diejenigen, die mehr daran interessiert sind, Roquette &amp; Cazes „flüssiges Gold“, die Roquette
                        &amp; Die Jahrgänge 2013 und 2014 von Cazes sind eine ausgezeichnete Wahl und erzielten beim Decanter World eine hohe Punktzahl
                        Weinpreise und International Wine Challenge.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Roquette &amp; Cazes — Quinta do Crasto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Quand deux titans de la viticulture se rencontrent, les chances qu'ils fassent autre chose que de superbes vins sont
                        maigrir. Et la joint-venture entre Jorge Roquette (Quinta do Castro) et Jean-Michel Cazes
                        (Château Lynch-Bages) en est la preuve. Fabriqué avec le savoir-faire Bordelaise et les raisins de la vallée du Douro
                        le résultat : Quinta do Crasto Roquette &amp; Cazes est l'hybride parfait entre histoire, capacité
                        et l'amitié. Bien que les deux maisons aient des racines très profondes dans l'histoire de la vinification - Quinta do
                        Crasto remonte à 1615 et Lynch Bages peut revendiquer un héritage du XVIe siècle - la JV est une
                        idée relativement récente, issue de la vision partagée de deux hommes.
                    </div>

                    <div class="howto-title2">Deux hommes: une vision</div>
                    <div class="howto-text">
                        Deux hommes, deux voix signifie bien sûr deux vins ; 2002 a vu le premier millésime de Xisto et 2006 a vu le jeune frère Roquette &amp; Cazes mis sur le marché. Xisto a été un succès immédiat, et l'offre de 2003 a été élue "Exposition Découverte" à Vinexpo 2005. Le superlatif de Caze
                        le savoir-faire œnologique a particulièrement bien fonctionné avec les cépages de la vallée du Douro, et les vins de Roquette
                        les fruits ont à leur tour répondu admirablement aux protocoles de vinification à la bordelaise de Caze. Ces
                        inclus accélérer le pompage pendant les trois premiers jours de fermentation et laisser un plus long
                        temps de macération, donnant à Xisto sa concentration exceptionnelle – une rareté incroyable pour un produit
                        de la vallée du Douro.
                    </div>

                    <div class="howto-title2">Xisto contre Roquette &amp; Caze?</div>
                    <div class="howto-text">
                        Du point de vue des investisseurs, Xisto est doublement convoité car la production est limitée à entre
                        3 000 à 4 000 bouteilles par an. 2011 Le prix moyen est d'environ 100 € la bouteille (en Europe) avec
                        les prix sont restés stables au cours des 24 derniers mois (mai-2019) et a obtenu 95 points de Wine
                        Avocat, suggérant que Xisto est un excellent ajout au portefeuille de tout investisseur en vin ou
                        cave. Pour ceux qui sont plus intéressés à boire Roquette &amp; « L'or liquide » de Caze, la Roquette
                        &amp; Les millésimes 2013 et 2014 de Cazes sont un excellent choix et obtiennent de bons résultats au Decanter World
                        Prix ​​du vin et défi international du vin.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Roquette &amp; Cazes — Quinta do Crasto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        When two winemaking titans meet, the chances of them making anything other than superb wines are
                        slim. And the joint venture between Jorge Roquette (Quinta do Castro) and Jean-Michel Cazes
                        (Château Lynch-Bages) proves just that. Made with Bordelaise know how and Douro valley grapes
                        the result: Quinta do Crasto Roquette &amp; Cazes is the perfect hybrid between history, ability
                        and friendship. Despite both houses having very deep roots in winemaking history - Quinta do
                        Crasto dates back to 1615 and Lynch Bages can claim 16th century heritage – the JV is a
                        relatively recent idea, stemming from the shared vision of two men.
                    </div>

                    <div class="howto-title2">Two men: one vision</div>
                    <div class="howto-text">
                        Two men, two voices of course means two wines; 2002 saw the first vintage of Xisto and 2006 saw younger sibling Roquette &amp; Cazes released onto the market. Xisto was an immediate success, and 2003s offering was voted as the “Exhibition Discovery” at Vinexpo 2005. Caze’s superlative
                        winemaking expertise worked particularly well with the Douro valley varietals, and Roquette’s
                        fruit in turn responded admirably to Caze’s Bordeaux-style vinification protocols. These
                        included speeding up pumping for the first three days of fermentation and leaving a longer
                        maceration time, giving Xisto its exceptional concentration – an incredible rarity for a product
                        from the Douro Valley.
                    </div>

                    <div class="howto-title2">Xisto vs. Roquette &amp; Caze?</div>
                    <div class="howto-text">
                        From a investors point of view Xisto is doubly covetable as production is limited to between
                        3,000-4,000 bottles annually. 2011 Average pricing is around €100 a bottle (in Europe) with
                        prices staying stable in the past 24-month (May-2019) and was awarded 95 points from Wine
                        Advocate, suggesting that Xisto is an excellent addition to any wine investor’s portfolio or
                        cellar. For those more interested in drinking Roquette &amp; Caze’s “liquid gold”, the Roquette
                        &amp; Cazes 2013 and 2014 vintages are an excellent choice, scoring high at the Decanter World
                        Wine Awards and International Wine Challenge.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RoquetteCazesQuinta",
    data() {
        return {
            select: {
                report: 'Roquette & Cazes — Quinta do Crasto',
                src: '/wine-guide/portugal/douro-valley/roquette-cazes-quinta'
            },
            items: [
                {report: 'Casa Ferreirinha', src: '/wine-guide/portugal/douro-valley/casa-ferreirinha'},
                {report: 'Howard’s Folly', src: '/wine-guide/portugal/douro-valley/howards-folly'},
                {
                    report: 'Prats and Symington (Chryseia)',
                    src: '/wine-guide/portugal/douro-valley/prats-and-symington'
                },
                {report: 'Quinta do Crasto', src: '/wine-guide/portugal/douro-valley/quinta-do-crasto'},
                {report: 'Quinta Do Vale Meao', src: '/wine-guide/portugal/douro-valley/quinta-do-vale-meao'},
                {report: 'Quinta Do Vallado', src: '/wine-guide/portugal/douro-valley/quinta-do-vallado'},
                {report: 'Quinta Do Vesuvio', src: '/wine-guide/portugal/douro-valley/quinta-do-vesuvio'},
                {
                    report: 'Roquette & Cazes — Quinta do Crasto',
                    src: '/wine-guide/portugal/douro-valley/roquette-cazes-quinta'
                },
                {report: 'Symington', src: '/wine-guide/portugal/douro-valley/symington'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Roquette & Cazes — Quinta do Crasto | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the finest wine from Roquette & Cazes — Quinta do Crasto, a renowned wine producer located in the Douro Valley region of Portugal. Experience their exceptional quality and unique taste.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
